export default "__VITE_ASSET__DQDEQ2A0__"